import cn from './items/cn';
import eu from './items/eu';
import us from './items/us';
import au from './items/au';
import ca from './items/ca';
import uk from './items/uk';
import de from './items/de';
import fr from './items/fr';
import it from './items/it';
import es from './items/es';
import jp from './items/jp';
import ph from './items/ph';

export type Locale = {
    locale: string;
    conver?: string;
    appId?: number | string;
    acceptLanguage?: string;
};
export const localeObj = {
    us,
    cn,
    ca,
    au,
    eu,
    uk,
    de,
    fr,
    it,
    es,
    jp,
    ph,
};

export type LocalesType = keyof typeof localeObj;

export const localeObjList = Object.values(localeObj);

export const defaultLocale = 'us';

// 获取国家列表;['us', 'ca']
export const localeList = localeObjList.map((item: any) => {
    return item.locale;
});

// 根据 locale 获取选中的国家obj值
export const getLocalObj = (locale: string) => {
    console.log('localeObjList---->>>', localeObjList);

    const list = localeObjList.filter((item: Locale) => {
        return item.locale == locale;
    });
    return list[0] || localeObjList[0];
};
